module.exports = __webpack_public_path__ + "img/nube.7a203ab5.png";